import { SHOP_CHECKOUT_SUBSCRIPTION_COMPLETE_PAGE } from "@/settings/constant";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
/** 'Z' 나 '+09:00' 같은 오프셋 표기가 붙어 있는지 */ const HAS_TIMEZONE = /[Zz]|[+-]\d{2}:?\d{2}$/;
/**
 * 결제 일자 표기 (시안 '2025.07.06 22:22:12').
 *
 * paidAt 은 UTC 지만 문자열 형태가 확정되지 않았다. '2026-08-19 13:22:12' 처럼 오프셋 표기가 없으면
 * dayjs 가 로컬 시각으로 해석해 9시간 어긋나므로, 그때는 UTC 로 못박아 변환한다.
 */ export const formatPaidAt = (paidAt)=>{
    const parsed = HAS_TIMEZONE.test(paidAt) ? dayjs(paidAt) : dayjs.utc(paidAt).local();
    return parsed.format("YYYY.MM.DD HH:mm:ss");
};
/** router.query 값은 string | string[] 이라 첫 값만 취한다 */ const single = (value)=>Array.isArray(value) ? value[0] : value;
const toNumber = (value)=>{
    const parsed = Number(single(value));
    return Number.isFinite(parsed) ? parsed : 0;
};
/** 가입 성공 직후 이동할 완료 화면 URL */ export const buildSubscriptionCompleteUrl = (param)=>{
    let { status , paidResult  } = param;
    const params = new URLSearchParams({
        status
    });
    // 체험이면 paidResult 가 null 이라 status 하나만 붙는다
    if (paidResult) {
        // 응답에 필드가 빠지면 String(undefined) 가 'undefined' 로 화면에 그대로 찍힌다.
        // (실제로 method/methodLabel 키가 어긋나 '결제 수단: undefined' 로 노출된 적이 있다.)
        // 값이 없으면 아예 싣지 않아 해당 행만 빠지게 한다.
        Object.entries(paidResult).forEach((param)=>{
            let [key, value] = param;
            if (value === undefined || value === null) return;
            params.set(key, String(value));
        });
    }
    return "".concat(SHOP_CHECKOUT_SUBSCRIPTION_COMPLETE_PAGE, "?").concat(params.toString());
};
/**
 * 완료 화면 쿼리 해석. status 가 없거나 모르는 값이면 null 을 반환한다.
 *
 * 결제 파라미터가 덜 왔을 때는 화면을 죽이지 않고 '결제 정보' 박스만 생략한다.
 * 가입은 이미 끝난 시점이라, 표시값 하나 때문에 완료 화면을 못 보여주는 쪽이 더 나쁘다.
 */ export const parseSubscriptionCompleteQuery = (query)=>{
    const status = single(query.status);
    if (status !== "trial" && status !== "active") return null;
    const orderId = single(query.orderId);
    const paidAt = single(query.paidAt);
    if (!orderId || !paidAt) return {
        status,
        paid: null
    };
    var _single;
    return {
        status,
        paid: {
            orderId,
            paidAt,
            methodLabel: (_single = single(query.methodLabel)) !== null && _single !== void 0 ? _single : "",
            regularPrice: toNumber(query.regularPrice),
            discountAmount: toNumber(query.discountAmount),
            paidAmount: toNumber(query.paidAmount)
        }
    };
};
